import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

const CUSTOM_ICONS = [
  'calendar_v2',
  'chapters_v2',
  'chat_v2',
  'check_nobg_v2',
  'check_v2',
  'clock_v2',
  'close_v2',
  'delete_v2',
  'download_v2',
  'edit_v2',
  'expand_v2',
  'final_v2',
  'info_v2',
  'language_v2',
  'linkedin_v2',
  // new lock-icon. maybe switch every occurrence of 'lock' for this, tbd
  'lock-filled_v2',
  'lock_v2',
  'map-pin_v2',
  'menu_v2',
  'milestone_v2',
  'note-create_v2',
  'note-edit_v2',
  'play_v2',
  'preview-play_v2',
  'rating_v2',
  'reduce_v2',
  'search_v2',
  'separator_anecdote_v2',
  'separator_certificate_v2',
  'separator_feedback_v2',
  'separator_link_v2',
  'separator_video_v2',
  'separator_interactive_v2',
  'separator_nextgen_quiz_v2',
  'separator_protocol_v2',
  'trainer_v2',
  'user_v2',
  'xing_v2',
  // design-system icons
  'troodi_info_v2',
  'troodi_filter_v2',
  'peer_session_v2',
  'community_session_v2',
  'sparring_session_v2',
];

@NgModule({
  imports: [MatIconModule, HttpClientModule],
  exports: [MatIconModule],
})
export class IconsModule {
  constructor(
    private readonly _matIconRegistry: MatIconRegistry,
    private readonly _domSanitizer: DomSanitizer,
  ) {
    CUSTOM_ICONS.forEach((icon: string) => {
      this._matIconRegistry.addSvgIcon(icon, this._domSanitizer.bypassSecurityTrustResourceUrl(`/portal/assets/img/${icon}.svg`));
    });
  }
}
